export default "__VITE_ASSET__C89R40Lh__ 100w";